/**
 * EO «Виджет» (01.11, решение владельца: «экран EO пусть называется виджет — и содержит там всё для работы с ним, в том числе
 * аналитику и проверки, что всё работает, а также аномальную активность»; ТЗ 1.17 EMB-019, §0.6 п. 68(7), п. 70; PLAN-V4 §6 шаг 15).
 * Пять частей суб-табами (паттерн «Конфигуратора»): «Сайты» — список, ключи, config по полям, вкл/выкл, тексты согласий, журнал,
 * замок «МК переведён»; «Код установки» — тег с основного и запасного адреса; «Работает ли» — экземпляры прокладки, адреса, сайты,
 * тревоги; «Аналитика» — числа OPS-006 и воронка из сводок; «Аномалии» — 7 суток, сети хешем. Только агрегаты без ПДн, «нет
 * данных» вместо нуля; адреса прокладки и экземпляры — только чтение (переменные выкладки V4). Выбранный сайт общий для частей.
 */
import { useState } from "react";
import { WidgetSites } from "./WidgetSites";
import { WidgetInstall } from "./WidgetInstall";
import { WidgetHealth } from "./WidgetHealth";
import { WidgetAnalytics } from "./WidgetAnalytics";
import { WidgetAnomalies } from "./WidgetAnomalies";
import css from "./widget.module.css";

type Part = "sites" | "install" | "health" | "analytics" | "anomalies";
const PARTS: { id: Part; label: string }[] = [
  { id: "sites", label: "Сайты" },
  { id: "install", label: "Код установки" },
  { id: "health", label: "Работает ли" },
  { id: "analytics", label: "Аналитика" },
  { id: "anomalies", label: "Аномалии" },
];

export function EoWidgetView() {
  const [part, setPart] = useState<Part>("sites");
  const [siteId, setSiteId] = useState<number | null>(null);
  return (
    <div className={css.wrap}>
      <nav className={css.subtabs} aria-label="Разделы виджета">
        {PARTS.map((p) => (
          <button key={p.id} type="button" className={`${css.stab} ${part === p.id ? css.stabOn : ""}`} aria-pressed={part === p.id} onClick={() => setPart(p.id)}>
            {p.label}
          </button>
        ))}
      </nav>
      <div className={css.scroll}>
        {part === "sites" ? <WidgetSites siteId={siteId} onSite={setSiteId} onInstall={(id) => { setSiteId(id); setPart("install"); }} />
          : part === "install" ? <WidgetInstall siteId={siteId} onSite={setSiteId} />
          : part === "health" ? <WidgetHealth />
          : part === "analytics" ? <WidgetAnalytics siteId={siteId} onSite={setSiteId} />
          : <WidgetAnomalies />}
      </div>
    </div>
  );
}
